import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import {
  Grid,
  IconButton,
  Typography,
} from '@material-ui/core';

import CloseIcon from '@material-ui/icons/Close';

import Button from '../Button';

import useStyles from './styles';

const DeleteConfirmation = (props) => {
  const {
    isLoading,
    disableConfirm,
    onConfirm,
    onCancel,
  } = props;
  const { t } = useTranslation();
  const classes = useStyles();

  const handleOnConfirm = () => {
    if (!isLoading && !disableConfirm) {
      onConfirm();
    }
  };

  return (
    <div className={classes.root}>
      <Grid
        container
        className={classes.heading}
        justifyContent="space-between"
        alignItems="center"
      >
        <Typography variant="h4">{t('component.label.delete', 'Delete')}</Typography>
        <IconButton size="small" onClick={onCancel}>
          <CloseIcon />
        </IconButton>
      </Grid>
      <Typography>
        {t('component.label.delete_confirmation_message', 'Are you sure you want to do this?')}
      </Typography>
      <Typography variant="caption">
        {t('component.label.cannot_undo', 'Note: You cannot undo this')}
      </Typography>
      <div className={classes.controls}>
        <Button variant="outlined" onClick={onCancel} isLoading={isLoading}>
          {t('component.label.cancel', 'Cancel')}
        </Button>
        <Button variant="contained" disabled={disableConfirm} onClick={handleOnConfirm} isLoading={isLoading}>
          {t('component.label.delete', 'Delete')}
        </Button>
      </div>
    </div>
  );
};

DeleteConfirmation.propTypes = {
  isLoading: PropTypes.bool,
  disableConfirm: PropTypes.bool,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
};

DeleteConfirmation.defaultProps = {
  isLoading: false,
  disableConfirm: false,
  onConfirm: () => {},
  onCancel: () => {},
};

export default DeleteConfirmation;
